<h2 mat-dialog-title>Import Floating Rain Student</h2>

<mat-dialog-content class="fr-import-content">
  <p class="hint">Search the legacy Floating Rain CSV for a single student and import them.</p>

  <div class="search-row">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Search by name</mat-label>
      <input
        matInput
        [(ngModel)]="searchTerm"
        (keyup.enter)="onSearch()"
        placeholder="e.g. Jane Smith"
        autocomplete="off" />
      <button mat-icon-button matSuffix (click)="onSearch()" [disabled]="isSearching" aria-label="Search">
        <mat-icon *ngIf="!isSearching">search</mat-icon>
        <mat-progress-spinner *ngIf="isSearching" diameter="18" mode="indeterminate"></mat-progress-spinner>
      </button>
    </mat-form-field>
  </div>
  <div class="search-actions">
    <button mat-flat-button color="primary" (click)="onSearch()" [disabled]="isSearching">
      <mat-icon>search</mat-icon>
      Search
    </button>
  </div>
  <mat-error *ngIf="searchError" class="error-text">{{ searchError }}</mat-error>

  <mat-card class="results-card" *ngIf="searchResults.length">
    <mat-selection-list [multiple]="false">
      <mat-list-option
        *ngFor="let student of searchResults"
        [selected]="selectedStudent?.customer_id === student.customer_id"
        (click)="selectStudent(student)">
        <div class="option-row">
          <div>
            <div class="name">{{ student.first_name }} {{ student.last_name }}</div>
            <div class="meta">
              <span *ngIf="student.email">{{ student.email }}</span>
              <span *ngIf="student.cell_phone">• {{ student.cell_phone }}</span>
              <span class="id-pill">ID: {{ student.customer_id }}</span>
            </div>
          </div>
          <mat-chip color="warn" selected *ngIf="student.already_imported">Already imported</mat-chip>
        </div>
      </mat-list-option>
    </mat-selection-list>
  </mat-card>

  <mat-card class="selected-card" *ngIf="selectedStudent">
    <mat-card-title>Selected student</mat-card-title>
    <mat-card-content>
      <div class="name">{{ selectedStudent.first_name }} {{ selectedStudent.last_name }}</div>
      <div class="meta">
        ID: {{ selectedStudent.customer_id }}
        <span *ngIf="selectedStudent.email">• {{ selectedStudent.email }}</span>
      </div>
      <mat-hint *ngIf="selectedStudent.already_imported" class="warn-text">
        A student with this legacy ID already exists in this studio.
      </mat-hint>
    </mat-card-content>
  </mat-card>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    (click)="importSelected()"
    [disabled]="!selectedStudent || isImporting">
    <mat-progress-spinner *ngIf="isImporting" diameter="18" mode="indeterminate"></mat-progress-spinner>
    <span *ngIf="!isImporting">Import student</span>
  </button>
</mat-dialog-actions>
